const SERVIDOR = 'https://www.mprn.mp.br/';

export const environment = {
  production: true,
  URL_SERVICO: SERVIDOR + 'contra/funcionarios.asmx/ValidarDadosInativo',
  URL_PORTALRH: SERVIDOR + 'contra/Default.aspx',
  CHAVE_SERVICO: 'topdownmprn',
  GOOGLE_RECAPTCHA_SITE_KEY: "6LdmuDQUAAAAAAx1KwXGllrxq0MtBpBYdYQn-g8i",
  
};



// WEBPACK FOOTER //
// D:/contracheque-inativos/src/environments/environment.ts